import { ChangeDetectionStrategy, Component, ElementRef, Input, signal, viewChild } from '@angular/core';
import type { ListItemComponent } from '@ui/shared/util-list';
import { DetailViewModule } from '@ui/shared/ui-detail-view';
import { DividerModule } from 'primeng/divider';
import type { PreventionListItemModel } from '../definitions/prevention-list-item.model';
import { Dialog } from 'primeng/dialog';
import { PreventionListItemDetailsComponent } from './prevention-list-item-details.component';
import { ButtonDirective } from 'primeng/button';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-prevention-item-details',
    templateUrl: './prevention-list-list-item.component.html',
    styleUrls: ['./prevention-list-list-item.component.scss'],
    imports: [
        DetailViewModule,
        DividerModule,
        Dialog,
        PreventionListItemDetailsComponent,
        ButtonDirective,
    ],
})
export class PreventionListListItemComponent implements ListItemComponent<PreventionListItemModel> {
    @Input()
    public listItem?: PreventionListItemModel;

    public isVisible = signal(false);
    public button = viewChild(ButtonDirective, { read: ElementRef });

    public onDialogHide(): void {
        (this.button()?.nativeElement as HTMLButtonElement | undefined)?.focus();
    }
}
